import { HomeActionTypes } from "./actionTypes";
import { ActionCreator, Action } from "../../../actions/actions";
import { SubAppConfig } from "../../../reducers/subAppsConfig.reducer";

export const HomeActionCreators: { [key: string]: ActionCreator } = {
    updateSubApps: (subApps: SubAppConfig[]) => ({
        type: HomeActionTypes.UPDATE_ACTIVE_SUBAPPS,
        payload: [...subApps]
    }),

    selectSubApp: (subApp: SubAppConfig) => ({
        type: HomeActionTypes.SELECT_SUBAPP,
        payload: { ...subApp }
    }),

    getUserInfo: () => ({
        type: HomeActionTypes.GET_USER_INFO
    }),

    logout: () => ({
        type: HomeActionTypes.LOGOUT
    }),

    editPassword: user_info_json => ({
        type: HomeActionTypes.EDIT_USER_PASSWORD,
        payload: user_info_json
    })
};
